// Skills samples retrived from database

// Popular with talents
export const TALENT_SKILLS = [
  "3D Modeling",
  "ABAP Development Programming",
  "Ability to study situation and offer prompt solution",
  "Accessibility and Inclusive Design",
  "Adaptability",
  "Administradora",
  "Administrador de redes",
  "Adobe CC",
  "Adobe Experience",
  "Adobe illustrator",
  "Adobe photoshop",
  "Adobe Premier Pro",
  "Adobe XD",
  "Ads",
  "Advertising",
  "After effects",
  "Agile Development",
  "Agile methodologies",
  "Agile Scrum Master and Validation Manager ",
  "Agility",
  "AI generated videos and images",
  "Ajax",
  "Algorithms",
  "Amazon",
  "Amazon Web Services",
  "Analysis, Design, Planning & Development Systems",
  "Analytical",
  "Analytical mind",
  "Analytical Skills",
  "Analytical thinking",
  "Analytics",
  "Analyze data",
  "Analyze requirements",
  "Analyze user need",
  "Analyzing content",
  "Analyzing data",
  "Analyzing problems",
  "Android Developer",
  "Android ecosystem",
  "Android foundations",
  "Android interactivity",
  "Android security",
  "Android UI",
  "and Security Audits",
  "Angular",
  "Animated graphics",
  "Ansible",
  "any type of job i can do full time",
  "Apache Airflow",
  "Apache Kafka",
  "Apex",
  "Apex Trigger",
  "API development",
  "API Gateway",
  "API Integration",
  "API testing",
  "API Testing (Postman)",
  "Appium",
  "Application design",
  "Application Lifecycle Management",
  "Application performance",
  "Application Security",
  "Application software,  Backup software",
  "Appraise products",
  "Approval Processes",
  "Architecture",
  "Architectures, Data lakes,Hadoop ",
  "Artical, blogs and any english content editor",
  "Artical writer",
  "Article writing for product ",
  "Artificial Intelligence",
  "As a computer operator",
  "ASP.Net",
  "- ASP.NET",
  "ASP.NET Web API",
  "Assess competitor",
  "Asset Management",
  "Assistant manager production ",
  "Atención al cliente ",
  "Attention to detail",
  "Autodesk Softwares (AutoCAD, Revit and Civil 3D)",
  "automated testing",
  "automation testing with robot framework using Python",
  "AWS",
  "AWS Amplify",
  "aws cloud",
  "AWS Cloud Platform",
  "AWS Elastic Compute (EC2)",
  "AWS Lambda",
  "AWS Load Balancer",
  "AWS Redshift",
  "AWS S3",
  "Azure",
  "Azure Data factory",
  "Azure DevOps",
  "Azure Synapse",
  "B2B product management",
  "Backend",
  "Backend Development",
  "backend engineer",
  "Bash",
  "Basic Math",
  "BDD approach",
  "Behavioral Psychology",
  "Big Data",
  "Bitbucket",
  "Bitcoin",
  "Blazor",
  "Blender",
  "Blockchain",
  "Blockchain ecosystem",
  "Blogs writing ",
  "Bookkeeping, accounting ",
  "boostrap",
  "Bootstrap",
  "Brand assets",
  "Brand/ company moderator",
  "Brand identity",
  "Brand & Identity",
  "Budgeting",
  "Bug fixes",
  "Bug fixing",
  "Bug tracking",
  "Build a brand",
  "Build brand/company presence",
  "Build brand/company trust",
  "Building user interfaces",
  "Business Analysis",
  "business card design",
  "Business Central",
  "Business Development",
  "Business Intelligence",
  "Business knowledge",
  "Business planning",
  "Business Savviness",
  "Business writing",
  "C",
  "C#",
  "C++",
  "Cad designer ",
  "Cakephp",
  "Call center",
  "Campaigns",
  "Camunda BPMN",
  "Canva",
  "C/C++",
  "C++ Developer",
  "C++ Developer ",
  "Celery",
  "Change and Incident Management",
  "chatbot development",
  "Chef",
  "cicd",
  "CI/CD ",
  "Cicd Pipelines",
  "CICS",
  "Cinema 4D",
  "C Language",
  "Clear voice and tone",
  "Client Management",
  "CLLE",
  "Cloud Architect",
  "Cloud Computing",
  "Cloud Developer",
  "Cloud Experience Lead",
  "cloudformation",
  "Cloud Security",
  "Cloud storage",
  "Cmake",
  "CNNs",
  "Coachable",
  "COBOL",
  "Cocoa Touch",
  "Codebases",
  "Coding knowledge",
  "Collaborating with stakeholders",
  "Collaboration",
  "Collaboration Skills",
  "Collaborative Teamwork",
  "Collect data",
  "Combine",
  "Commercial",
  "Communication",
  "Communication skills",
  "Communication Skills",
  "Community Engagement",
  "Community management",
  "Community Management",
  "Community support",
  "Computer",
  "Computer science",
  "Computer skill",
  "Computer Vision",
  "Concise writing",
  "Concur",
  "Conducting market research",
  "Conflict Management Skills",
  "Confluence",
  "Containers",
  "Content ",
  "content creator",
  "Content design",
  "Content distribution",
  "Content strategy",
  "Content writer and marketing manager ",
  "Content writing",
  "content writting",
  "Continuous Improvement",
  "Control M; Connect Direct; Service Now; WorkFlow; MDCMS.",
  "Converting data",
  "Coordination",
  "copy paste",
  "Copyrighting ",
  "Copywriting",
  "Core animation",
  "Core data",
  "Core graphics",
  "Core java",
  "Core text",
  "Corporate Governance",
  "Correct deficiencies",
  "Cost function",
  "Creating campaigns",
  "Creating dashboards and reports",
  "Creating data visualizations",
  "Creating procedures",
  "Creating systems",
  "Creative ",
  "Creative Development",
  "Creativity",
  "Critical Thinking",
  "CRM",
  "CRM Skills",
  "CRM Software",
  "Cross functional",
  "Cross-functional team leadership",
  "Cross Platform",
  "Cryptocurrency",
  "Cryptography",
  "CSS",
  "Cucumber",
  "Customer care",
  "Customer engagement",
  "Customer Service",
  "Customer Success Management",
  "Cybersecurity Testing",
  "Cybersecurity trends",
  "Cypress",
  "Dart",
  "Data Acquisition",
  "Data analysis and exploration",
  "Data analyst ",
  "Data analytical",
  "Database Administration",
  "Database Design",
  "Database Development",
  "Database management",
  "Database Management",
  "Database systems",
  "Database Testing",
  "Databricks",
  "Data cleaning",
  "Data cleaning and preparation",
  "Data collection",
  "Data Collector's data manager data entry experts ",
  "Data conversion",
  "Datadog Monitoring",
  "Data eantry",
  "Data Engineering",
  "Data entry",
  "Data Governance",
  "Data handling",
  "Data Loader",
  "data management",
  "Data management",
  "data migration, data modeling",
  "Data mining",
  "Data mining ",
  "Data pipeline",
  "Data prep",
  "Data processing",
  "Data Science",
  "Data Scientist",
  "Data Storytelling",
  "Data structures",
  "Data visualization",
  "Data Visualization",
  "Data warehousing",
  "Data Wrangling",
  "DAX",
  "DBMS software",
  "dbt",
  "debugging",
  "decentralized networks",
  "Deep Learning",
  "Define features",
  "Defining requirements",
  "Derivatives",
  "Desarrollador backend ",
  "Design",
  "Design concepts",
  "Designer graphics photo image write in msgs taping ",
  "Design features",
  "designing solutions",
  "Design patterns",
  "Design process",
  "Design production",
  "Design System",
  "Design Thinking",
  "Detailed Oriented",
  "Determination",
  "Developing applications",
  "Developing programs",
  "Development efficiency",
  "DevOps",
  "Devops engineer",
  "Dev Tools",
  "Digital engagement",
  "Digital media",
  "Discord",
  "Diseñador junior",
  "Diseño de páginas web ",
  "Distributed Microservice Architecture",
  "Distributed systems",
  "Django",
  "Django-REST",
  "Docker",
  "Documentation",
  "Documentation preparation",
  "Domain knowledge",
  "Dynamics 365",
  "Dynamics 365 Business Central Functional consultant ",
  "Dynamics CRM",
  "DynamoDB",
  "Edge cases",
  "Editing content",
  "Efficiency & top-notch organization",
  "Electronics and Telecommunications Engineering",
  "ELT/ETL",
  "email marketer",
  "Email Marketing manager",
  "Email Proficiency",
  "Email writing",
  "Embedded C",
  "Embedded Engineering",
  "Ember.js",
  "Emergency medical technician ",
  "Emotional Intelligence",
  "Empathetic",
  "Endpoint Security",
  "Engineer",
  "Engineering Management",
  "English fluent",
  "Enhancement of product",
  "Entity Framework",
  "ES6",
  "Ethereum",
  "ethersjs",
  "ETL",
  "Events",
  "Experimentation",
  "Explain Complex Details",
  "ExpressJS",
  "FastApi",
  "Fast Formula",
  "Feature implementation",
  "Figma",
  "Finance",
  "Finding patterns",
  "Firebase",
  "Firewalls",
  "Flask",
  "Flexbox",
  "Flexibility",
  "Flow",
  "Flutter",
  "Forecasting",
  "Foundry",
  "Freelance ",
  "Freelancer ",
  "Front-end ",
  "Frontend developer",
  "Frontend Development",
  "Full Stack Developer .Net",
  "Fullstack Engineer",
  "Full Stack Java Developer",
  "Full stack maintenance",
  "Full stack web developer ",
  "Full stock ",
  "Functionality and maintenance",
  "Functional Testing",
  "Game",
  "Gather information",
  "Gathering data",
  "Gatsby",
  "GCP",
  "General reliability",
  "Generative AI ",
  "Git",
  "Git ",
  "Github",
  "Github Actions",
  "Gitlab",
  "GitOps",
  "Git: Version control",
  "Goal-oriented",
  "Golang",
  "Good leader Good communication ",
  "Google",
  "Google Ads",
  "Google Cloud",
  "Google Slides",
  "Google Tag Manager",
  "Google Trends",
  "Go To Market",
  "Governance",
  "GPT",
  "Gradients",
  "Grafana",
  "Graphic designer",
  "Graphic designer,",
  "Graphic Design, Video Edit, Logo, Banner, Thumbnail etc",
  "Graphics",
  "graphics design ",
  "Graphics designer ",
  "GraphQL",
  "Growth hacking",
  "Guest Posting ",
  "Hacking techniques",
  "Handwriting Assignment work ",
  "Hardhat",
  "HDFS",
  "Helm",
  "Hibernate",
  "Hi-fi prototype",
  "High Empathy",
  "Hive",
  "HRIS",
  "HSE health safety inviroment ",
  "Html",
  "HTML",
  "Html5",
  "HTML5 & CSS3",
  "HTML5,CSS3, Bootstrap4, ",
  "HTML & CSS",
  "hubspot",
  "Human Resource Management System",
  "Human resources generalist",
  "Hyperion",
  "Hyperledger",
  "IAM : Wso2 , SAML , SSO , SSL",
  "IBM Cloud",
  "Identify deficiencies",
  "Identifying data",
  "Identifying patterns and trends",
  "Identify new customers",
  "Identify new markets",
  "Identify opportunities",
  "IDS/IPS",
  "Illustrate and prototype",
  "Illustrations",
  "Implement features",
  "Industrial Automation",
  "Influencer mkt ",
  "Informatica",
  "Information architecture",
  "Information management",
  "Information technology",
  "infrastructure as code",
  "Infrastructure Engineer",
  "Innovation",
  "Innovative, problem solver, team working, ",
  "Insights",
  "Integration",
  "Interaction designer",
  " Interpersonal Skills",
  "Interpreting data",
  "inVision",
  "Ionic Framework",
  "iOS development",
  "IoT",
  "IT audit methodologies",
  "ITSM Service Manager",
  "J2EE",
  "Jasmine and Karma",
  "Java",
  "Javacsript",
  "Java Developer",
  "Javascript",
  "****Javascript",
  "JavaScript",
  "JCL",
  "Jenkins",
  "Jenkins Zeplin, Figma",
  "Jest",
  "Jetpack compose ",
  "Jira",
  "JIRA",
  "JMeter",
  "JPA",
  "jQuery",
  "JQuery",
  "Json Web Token (JWT)",
  "JSX",
  "Junit",
  "Kafka",
  "Keycloak",
  "Keyword research",
  "Knowledge CSS3",
  "Knowledge HTML5",
  "Kotlin",
  "Kubernetes",
  "Laravel",
  "Leadership",
  "Lead Generation",
  "Lean Startup",
  "Lightning Web Component",
  "Linear Algebra,Step function",
  "link building",
  "LinkedIn Ads",
  "Linux",
  "Listening",
  "LLMs",
  "Logging and Monitoring",
  "Logit function",
  "Logo design",
  "Logos",
  "Looker Studio",
  "M365",
  "Machine learning",
  "Magento",
  "Mainframe ",
  "Maintain library",
  "Making connections",
  "Management",
  "Management, planning, data analysis.",
  "manager",
  "Manage social accounts",
  "manual testing",
  "Marketing",
  "Marketing digital ",
  "Marketing strategy",
  "Market research",
  "Market trends",
  "Material UI",
  "Mathematics",
  "MATLAB",
  "Maven",
  "Mentoring",
  "merchandise inventories",
  "MERN",
  "MERN Stack Developer",
  "Meta Ads",
  "Microfrontend",
  "Microservices",
  "Microsoft - Advanced",
  "Microsoft Azure",
  "Microsoft defender",
  "Microsoft Excel",
  "Microsoft - intermediate",
  "Microsoft Office",
  "Microsoft - Proficient",
  "Microsoft SQL Server",
  "Microsoft word",
  "MicroStrategy",
  "Mining data",
  "Miro",
  "ML algorithms",
  "ML frameworks",
  "ML libraries",
  "ML models",
  "MLOps",
  "ML research",
  "ML schemes",
  "ML systems",
  "ML use cases",
  "Mobile Application Testing",
  "Mobile development life cycle",
  "Mobile integration",
  "Mobile landscape",
  "Mobile phone 📴 ",
  "Mobile testing",
  "Mobile trends",
  "Mockups",
  "Modeling tools",
  "Models",
  "Modern C++ (11/14/17)",
  "MongoDB",
  "Monitoring",
  "Monitoring campaigns",
  "Motion graphic",
  "Motion graphics composition ",
  "Movies",
  "MS office",
  "Multi-headed code",
  "Multivariate calculus",
  "MVC",
  "MVVM",
  "MySQL",
  "Natural language processing",
  "Natural Language Processing",
  "Navigation implementation",
  "Negotiation",
  "Negotiation in sales ",
  "nestjs",
  "Nestjs micro service base API integration ",
  ".Net",
  ".NET",
  ".NetCore",
  "NetSuite",
  "Network Administration ",
  "Network Engineering",
  "Networking fundamentals ",
  "Network management",
  "Netwroking Protocols- MQTT, TCP/IP",
  "Neural network architectures",
  "NextJs ",
  "NFT",
  "Nginx",
  "Node",
  "node js ",
  "Node.JS",
  "Node+npm",
  "NoSQL",
  "NoSQL, Hadoop",
  "Nuxt",
  "Objective-C",
  "Odoo ERP / CRM",
  "Office 365 Security",
  "OLAP, SSAS",
  "Online worker",
  "Only electrical ",
  "OOP",
  "OpenCV",
  "Open source projects",
  "Operations",
  "Optimization",
  "Optimize product content",
  "Optimizing content",
  "Oracle",
  "Oracle Cloud",
  "Oracle development",
  "Oracle EBS",
  "Oracle Financial",
  "Oracle HCM",
  "Oracle Infrastructure",
  "Oracle Integration",
  "Oracle SCM",
  "oracle sql",
  "Organization",
  "Organizational data",
  "Organized",
  "Other editing software",
  "Overseeing team of creators",
  "Paid Media",
  "Painting ",
  "Pandas",
  "Part time",
  "Penetration Testing",
  "Peoplesoft",
  "Performance",
  "performance testing",
  "Persuasion",
  "Photo editing ",
  "Photo retoucher",
  "Photoshop",
  "Photoshop ",
  "Php",
  "PHP",
  "PHP Yii2",
  "PL/SQL",
  "PLSQL Developer ",
  "PostgreSQL",
  "Postman",
  "Power Apps",
  "Power BI",
  "power query",
  "Powershell Scripting",
  "Preact",
  "Predictive modeling ",
  "Presales Engineer",
  "Presentation skills",
  "Presentation Skills",
  "Presenting their findings",
  "Prioritization",
  "Prisma ORM",
  "proactivo",
  "Probability and Statistics",
  "Problem solver",
  "Problem solving",
  "Problem-solving",
  "Problem Solving",
  "Problem-Solving",
  "Problem-solving skills",
  "Process Builder",
  "Product Design",
  "Product development lifecycle",
  "Production timelines",
  "Product Knowledge",
  "Product managment",
  "Product Owner",
  "Product planning",
  "Programming (Java, C++, C#, Python, SQL)",
  "Project life cycle",
  "Project management",
  "Project Management Skills",
  "Promotion and Marketing",
  "Proof reading ",
  "Prospecting",
  "Protecting data",
  "Prototyping",
  "Public speaking",
  "Public Speaking",
  "Public storage",
  "Pyspark",
  "Python",
  "Python developer ",
  "PyTorch",
  "QA Analyst ",
  "QA Automation with Playwright",
  "QA Methodologies",
  "Qt, QML",
  "Quadient Inspire",
  "Qualitative research",
  "Qualitative Research",
  "quality assurance",
  "Quantitative research",
  "R",
  "RabbitMQ",
  "Ranking data",
  "React",
  "React Hooks",
  "React.js",
  "ReactJS",
  "React Native",
  "ReactQuery",
  "Real Time Software",
  "Recruiter Lite",
  "Recruitment ",
  "redactor",
  "Redis",
  "Redux",
  "Regression Testing",
  "Reinforcement Learning",
  "Relationship Management",
  "Release testing",
  "Reporting technologies, Predictive analytics",
  "Research",
  "Research quality",
  "Research Skills",
  "Research & Strategy",
  "Responsive website ",
  "REST APIs",
  "Rest Assurred",
  "RESTful API",
  "RESTful API Design",
  "REST web services",
  "Retrofit",
  "Risk Assessment",
  "Roadmap",
  "RPA",
  "RPG",
  "RPG IV",
  "Rpgle",
  "Ruby",
  "Ruby on Rails",
  "Rust",
  "RXJS",
  "Saas",
  "Sale and Business ",
  "Sale man",
  "Sales",
  "Sales Experience",
  "Sales Expert",
  "Salesforce",
  "Salesforce developer",
  "Sales forecasting",
  "Sales Manager",
  "Sales man marketing ",
  "Sanity Testing",
  "SAP",
  "SAP Project Manager",
  "SAS",
  "sass",
  "Scala",
  "Scikit-learn",
  "Scrum",
  "Scrum Ceremonies",
  "Scrum Master",
  "SCSS",
  "SDET",
  "Security Audits",
  "Security perimeter",
  "Selenium",
  "Self-Motivated",
  "Semantic-UI",
  "Senior Backend Engineer",
  "Senior DevOps Engineer",
  "Senior Software Engineer - iOS",
  "SEO",
  "SEO optimization",
  "Sequelize",
  "Serverless",
  "Server-side Less",
  "Server-side SAAS",
  "ServiceNow",
  "Service-oriented architecture",
  "shellscripting",
  "Shell Scripting",
  "Ship features",
  "Shopify theme development",
  "Sitecore Experience Platform",
  "Sketch",
  "Sketch design",
  "Smart Contracts Developement",
  "Smoke Testing ",
  "Snowflake",
  "Social media",
  "social media management ",
  "Social Media Marketing",
  "Social Media Skills",
  "Socket.io",
  "Software design",
  "Software Developer Engineer ",
  "Software development",
  "Software Development Kit (SDK)",
  "Software Development Life Cycle",
  "Software Engineer ",
  "Software Requirements Specifications (SRS)",
  "Software test engineer",
  "Solana",
  "SOLID",
  "Solidity",
  "Soporte tecnico tandem",
  "SOQL",
  "Spark",
  "Spreadsheets",
  "Spring Boot",
  "Spring Cloud",
  "Spring Framework",
  "Sprints",
  "SPSS",
  "Sqa engineer",
  "SQL",
  "****SQL",
  "SQL and NoSQL Database",
  "SQL databases",
  "SQL development",
  "SQL, NoSQL",
  "SQL Query Optimization",
  "SQLRPGLE ",
  "SQL Server",
  "SQL Server, cloud computing design",
  "Sqoop",
  "Sr. Marketing Consultant",
  "SR. Service Delivery Implementation Consultant",
  "SSIS",
  "SSRS",
  "Statistical analysis",
  "Statistical Analysis",
  "Statistical and Mathematical skills",
  "Statistical knowledge",
  "Statistical programming languages",
  "Statistics",
  "Storyboards",
  "Storybook",
  "Storytelling",
  "Strategic planning",
  "Strategize",
  "Strategy",
  "Strategy planning",
  "Studying data science",
  "Styled-components",
  "Supervised Learning",
  "Support Engineer",
  "Svelte",
  "Swift",
  "SwiftUI",
  "Symfony",
  "System creation",
  "System Design",
  "Systems",
  "Systems Administrator",
  "Systems development lifecycle",
  "Systems Implementation",
  "Systems solutions",
  "System Testing",
  "Tableau",
  "Tactics and execution",
  "Tailwind css ",
  "Talend, Pentaho ",
  "Talent Networking",
  "Task organization",
  "Team environment",
  "Team Management",
  "Teamwork",
  "Team work",
  "Technical",
  "Technical Analysis",
  "Technical and Functional Documentation",
  "Technical feasibility",
  "Technical Recruiting",
  "Technical support",
  "Technical Writer",
  "Technical Writing ",
  "Technology trends",
  "TensorFlow",
  "Terraform",
  "Test Automation Tools (Espresso, Appium)",
  "Test Case Design and Execution",
  "Test Cases Design and Execution",
  "Test Driven Development",
  "Testing",
  "Testing and debugging",
  "Testing Frameworks (Selenium, Cypress, JUnit)",
  "Testing Frameworks (Selenium, Cypress, JUnit, NUnit)",
  "thinking",
  "Third-party API’s",
  "Third-party libraries",
  "Ticket management",
  "TikTok Ads",
  "Time management",
  "Time Management",
  "Toad Data Modeler",
  "To-market plans",
  "Traditional & digital marketing",
  "Training",
  "Transforming data",
  "Translation",
  "translator english to spanish",
  "Trends",
  "Troubleshooting",
  "Trouble shooting",
  "Troubleshooting software",
  "tRPC",
  "Truffle",
  "Twitter",
  "Twitter Ads",
  "TypeScript",
  "Typesetting ",
  "Typing",
  "UI Component Development (Storybook)",
  "UIKit",
  "UI / UX",
  "UML Tools",
  "Understanding of HTML",
  "Unit-testing",
  "Unity",
  "Unix",
  "Unreal Engine",
  "Unsupervised Learning",
  "UPI Payment, AEPS Payment",
  "Usability",
  "Usability testing",
  "User empathy",
  "User Experience and Strategy",
  "User insights",
  "User journey maps",
  "User needs",
  "User personas",
  "User research understanding",
  "User stories",
  "UX designer",
  "UX design understanding",
  "VB.NET",
  "Vector function",
  "Ventas al publico ",
  "Vercel",
  "Verifying data quality",
  "Video editing ",
  "Video editor",
  "Video editor and thumbnail editor",
  "Video editor copy paste typing master manager",
  "Video games",
  "Virtual Machine",
  "Virtual networks",
  "Visual Basic",
  "Visual communication",
  "Visual Designer",
  "Visual effects",
  "Visual identity",
  "Visualization",
  "Visualizing data",
  "Visual Studio Code",
  "Vite",
  "VMware",
  "VPN",
  "Vue",
  "Vue.js",
  "Waterfall methodologies",
  "Web3",
  "Web3 Management ",
  "Web3 space ",
  "Web Accessibility ",
  "Web app testing ",
  "Web design",
  "Web Design. HTML, JavaScript, CSS, ASP, PHP",
  "Web dev",
  "Web developer ",
  "Webflow",
  "Web implementation",
  "Webpack",
  "Web-Proxy",
  "web scraping",
  "Website design",
  "Windows",
  "Windows Azure",
  "Wireframing",
  "WordPress",
  "WordPress Theme Development",
  "Workday",
  "Workflows",
  "Working with data",
  "Workshops",
  "Work with CSS selectors",
  "Work with HTML tags",
  "WPF",
  "Write CSS selectors",
  "Writer",
  "Write semantic HTML tags",
  "Writes microcopies",
  "Writing",
  "Writing and editing",
  "Writing content",
  "Writing reports",
  "Writing skills",
  "Writting in social media manager",
  "Xamarin Forms",
  "Xcode",
  "XML",
  "YouTube subtitles ",
  "Zustand"
];
